// extracted by mini-css-extract-plugin
module.exports = {"footer":"styles_footer__3Rn1Z","content":"styles_content__Wzl_L","selectAll":"styles_selectAll__-p0a3"};